export default {
    wfLandingPage: 'https://worldfavor.com',
    wfLogin: 'https://portal.worldfavor.com/login',
    wfJoin: 'https://worldfavor.com/join',
    wfPublicProfileBaseUrl: 'https://profile.worldfavor.com/',
}
